import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './MyAgencyInfo.css';

const MyAgencyInfo = ({ user }) => {
  const { currentUser } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setLoading(true);
        
        // Use the user prop if available, otherwise use currentUser from context
        const userData = user || currentUser;
        
        if (!userData) {
          setError('User data not available');
          setLoading(false);
          return;
        }
        
        // For demo purposes, just use the current user data
        // In a real app, you would fetch detailed profile data from the server
        setProfile({
          name: userData.name || 'Not provided',
          email: userData.email || 'Not provided',
          role: userData.role || 'User',
          phone: userData.phone || 'Not provided',
          address: userData.address || 'Not provided',
          company: userData.company || 'Not provided',
          joinDate: userData.createdAt 
            ? new Date(userData.createdAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })
            : 'Not available'
        });
        
        setLoading(false);
      } catch (err) {
        console.error('Error fetching user profile:', err);
        setError('Failed to load your profile information');
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [currentUser, user]);

  if (loading) {
    return (
      <div className="profile-loading">
        <div className="profile-spinner"></div>
        <p>Loading your profile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="profile-error">
        <p>{error}</p>
        <button 
          onClick={() => window.location.reload()}
          className="profile-retry-btn"
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-header">
        <h2>My Profile</h2>
      </div>
      
      {profile && (
        <div className="profile-content">
          <div className="profile-section">
            <h3>Personal Information</h3>
            <div className="profile-grid">
              <div className="profile-item">
                <label>Name</label>
                <p>{profile.name}</p>
              </div>
              <div className="profile-item">
                <label>Email</label>
                <p>{profile.email}</p>
              </div>
              <div className="profile-item">
                <label>Phone</label>
                <p>{profile.phone}</p>
              </div>
              <div className="profile-item">
                <label>Address</label>
                <p>{profile.address}</p>
              </div>
            </div>
          </div>
          
          <div className="profile-section">
            <h3>Account Information</h3>
            <div className="profile-grid">
              <div className="profile-item">
                <label>Role</label>
                <p>{profile.role}</p>
              </div>
              <div className="profile-item">
                <label>Company</label>
                <p>{profile.company}</p>
              </div>
              <div className="profile-item">
                <label>Member Since</label>
                <p>{profile.joinDate}</p>
              </div>
            </div>
          </div>
          
          <div className="profile-actions">
            <button className="profile-edit-btn">Edit Profile</button>
            <button className="profile-change-pw-btn">Change Password</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyAgencyInfo;
